import PropTypes from 'prop-types';
import { paletteTypes } from '../../../styles';

const noop = () => {};

export const propTypes = {
  style: PropTypes.object,
  color: PropTypes.oneOf(paletteTypes),
  textColor: PropTypes.oneOf(paletteTypes),
  size: PropTypes.oneOf([
    'default',
    'small',
    'large',
  ]),

  leftButton: PropTypes.node,
  rightButton: PropTypes.node,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,

  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,

  disabled: PropTypes.bool,
  rounded: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.string,
};

export const defaultProps = {
  style: undefined,
  color: 'default',
  textColor: 'default',
  size: 'default',

  leftButton: undefined,
  rightButton: undefined,
  leftIcon: undefined,
  rightIcon: undefined,

  onBlur: noop,
  onChange: undefined,
  onFocus: noop,

  disabled: false,
  rounded: false,
  label: '',
  value: '',
};



// WEBPACK FOOTER //
// ./src/components/ui/TextField/types.js